export default () => ({
  isConnected: false,
  connectionUrl: null,
  connectionGroups: [],
  timeoutId: null,
});
